import { apiSlice } from "redux/Api.Slice";
import * as URL from "api/api/apiUrls";
const postConfig = {
  query: (body) => ({
    method: "POST",
    body: body,
  }),
  transformResponse: (response) => {
    return response.data;
  },
};

const getConfig = {
  query: () => ({
    method: "GET",
  }),
  transformResponse: (response) => {
    return response.data;
  },
};


const IFastService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCities: builder.mutation({
      ...postConfig,
      query: () => ({
        url: URL.IFAST.GET_CITIES,
        ...getConfig,
      }),
    }),
    getCityAreas: builder.mutation({
      ...postConfig,
      query: (body) => ({
        url: URL.IFAST.GET_AREAS,
        ...postConfig.query(body),
      }),
    }),
    sendOrderToIfast: builder.mutation({
      ...postConfig,
      query: (body) => ({
        url: URL.IFAST.CREATE_ORDER,
        ...postConfig.query(body),
      }),
    }),
    checkOrderStatus: builder.mutation({
      ...postConfig,
      query: (body) => ({
        url: URL.IFAST.GET_STATUS,
        ...postConfig.query(body),
      }),
    }),
    cancelIfastOrder: builder.mutation({
      ...postConfig,
      query: (body) => ({
        url: URL.IFAST.DELETE_ORDER,
        ...postConfig.query(body),
      }),
    }),
  }),
});
export const {
    useGetCitiesMutation,
    useGetCityAreasMutation,
    useSendOrderToIfastMutation,
    useCheckOrderStatusMutation,
    useCancelIfastOrderMutation
} = IFastService;
export default IFastService;
